import React from 'react'
import { Divider } from '../atoms'

const VerticalProgressBar = ({mainclasses, child, titleclass, title}) => {
  return (
    <div className={mainclasses} style={{borderColor: '#E5E8F0'}}>
      <div className={titleclass} style={{color: '#4D6189'}}>{title}</div>
      <Divider classes='w-full my-4' />
      <section className='py-5' class="timeline">
        <ul>
          {child}
        </ul>
      </section>
    </div>
  )
}

export default VerticalProgressBar